import { render } from "./technischerSupport.vue?vue&type=template&id=20f7650d"
import script from "./technischerSupport.vue?vue&type=script&lang=js"
export * from "./technischerSupport.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/IdeaProjects/eurogate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__